import { combineReducers } from "redux";
import mainReducer from "./scenes/Main/main.slice";
import detailsReducer from "./scenes/Details/details.slice";
import chargesReducer from "./scenes/Charges/charges.slice";
import fuelAndLubricantsReducer from "./scenes/FulesAndLubricants/fuelsAndLubricants.slice";
import serviceAndRepairReducer from "./scenes/ServiceAndRepair/serviceAndRepair.slice";
import registrationAndTachographReducer from "./scenes/RegistrationAndTachograph/registrationAndTachograph.slice";

const rootReducer = combineReducers({
  main: mainReducer,
  details: detailsReducer,
  charges: chargesReducer,
  fuelsAndLubricants: fuelAndLubricantsReducer,
  serviceAndRepair: serviceAndRepairReducer,
  registrationAndTachograph: registrationAndTachographReducer,
});

export default rootReducer;
